import { defineRecipe } from '@chakra-ui/react';

export default defineRecipe({
  base: {
    borderRadius: { base: 0, md: 'xl' },
    '&:first-of-type': {
      borderTopRadius: 'xl',
    },
    '&:last-of-type': {
      borderBottomRadius: 'xl',
    },
  },
});
